import { render } from "./WorkersComponent.vue?vue&type=template&id=57c71ce4&scoped=true"
import script from "./WorkersComponent.vue?vue&type=script&lang=js"
export * from "./WorkersComponent.vue?vue&type=script&lang=js"

import "./WorkersComponent.vue?vue&type=style&index=0&id=57c71ce4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c71ce4"]])

export default __exports__